import { $, $$, isTablet } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-login-header]')) return;

  mobileMenu();
  selectLanguage();
  updateScrolledState();
  datalayerHeaderLinks();

  window.addEventListener('scroll', updateScrolledState, { passive: true });
}

function mobileMenu() {
  const openMenu = $('[data-au-login-header-open]');
  const closeMenu = $('[data-au-login-header-close]');
  const linksContainer = $('[data-au-login-header-links]');

  if (!openMenu || !closeMenu || !linksContainer) return;

  openMenu.addEventListener('click', () => {
    linksContainer.classList.add('au-login-header__right--open');
  });

  closeMenu.addEventListener('click', () => {
    linksContainer.classList.remove('au-login-header__right--open');
  });

  isTablet.addEventListener('change', () => {
    linksContainer.classList.remove('au-login-header__right--open');
  });
}

function selectLanguage() {
  const links = $$('[data-au-login-header-language]');

  links.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.classList.contains('au-login-header__language-link--inactive')) {
        links.forEach((l) => l.classList.toggle('au-login-header__language-link--inactive'));
      }
    });
  });
}

function updateScrolledState() {
  const header = $('[data-au-login-header]');
  if (!header) return;
  header.classList.toggle('au-login-header--scrolled', window.scrollY > 40);
}

function datalayerHeaderLinks() {
  $$('[data-au-login-header-language]').forEach((language) => {
    language.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `login_${removeAccentMarkAndUppercase(clickText)}`;
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  });

  $('[data-au-login-header-help]').addEventListener('click', (e) => {
    e.preventDefault();
    const el = e.currentTarget;
    const clickText = el.querySelector(':not([data-au-icon])').innerText;
    const item_id = `login_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickEnlace',
      item_id,
    });
  });
}
export default { init };
